export default __webpack_public_path__ + "static/media/not_found_page.2897be7b.svg";